import { FC, useEffect, useState } from 'react';
import { useAppSelector } from '@store/hooks';
import {
  selectIsUsersLoading,
  selectUsersDataFilterAuthPerson,
  selectUsersDataFilterDirector,
} from '@features/workspace/store/selectors';
import Grid from '@mui/material/Grid';
import { Box, Card, CardContent, Divider } from '@mui/material';
import { BankingQuickLinks } from '@features/workspace/components/banking-quick-links';
import { CreditQuickLinks } from '@features/workspace/components/credit-quick-links';
import { CustomerApplicationStatus } from '@features/workspace/components/customer-application-status';
import { CustomerProducts } from '@features/workspace/components/customer-products';
import { CollapseGroup } from '@features/workspace/components/shared/collapse-group';
import { ActionLinkAdd } from '@features/workspace/components/controls/action-link';
import Notes from '@features/workspace/views/company/notes';
import { UserManagementMode } from '@features/workspace/components/users/utils/constants';
import Contacts from '../../components/users';
import { CompanyView } from './components/company-view';

const CustomerProfileView: FC<any> = () => {
  const [hasBankingProduct] = useState(false);
  const [hasFundingProduct] = useState(false);

  const isUsersLoading = useAppSelector(selectIsUsersLoading);
  const authPersons = useAppSelector(selectUsersDataFilterAuthPerson);
  const directors = useAppSelector(selectUsersDataFilterDirector);

  useEffect(() => {
    document.title = 'Lula Support - Customer Details';
    }, []) //eslint-disable-line

  return (
    <>
      <Card>
        <CardContent>
          <Grid container spacing={6}>
            <Grid item md={6} xs={12}>
              <CompanyView />
            </Grid>
            <Grid item md={6} xs={12}>
              <CollapseGroup
                expandByDefault
                header="Customer application"
                id="customerApplicationStatus"
              >
                <CustomerApplicationStatus />
              </CollapseGroup>
              <Divider />

              <Box mt={2.5}>
                <CustomerProducts />
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <CollapseGroup
            button={
              <ActionLinkAdd uri="/customer/company/directors/create">
                Add director
              </ActionLinkAdd>
            }
            counter={directors?.length || 0}
            header="Directors"
            id="directors"
            isCounterLoading={isUsersLoading}
          >
            <Contacts
              getEditUrl={(id) => `/customer/company/directors/${id}/edit`}
              type={UserManagementMode.Director}
            />
          </CollapseGroup>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <CollapseGroup
            button={
              <ActionLinkAdd uri="/customer/company/auth-persons/create">
                Add auth person
              </ActionLinkAdd>
            }
            counter={authPersons?.length || 0}
            header="Authorised person"
            id="auth-persons"
            isCounterLoading={isUsersLoading}
          >
            <Contacts
              getEditUrl={(id) => `/customer/company/auth-persons/${id}/edit`}
              type={UserManagementMode.AuthPerson}
            />
          </CollapseGroup>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <CollapseGroup
            counter={0}
            header="Notes"
            id="notes"
            // TODO: disabling this button for now
            // button={
            //   <ActionLinkAdd uri={'/customer/company/notes/create'}>
            //     Add Note
            //   </ActionLinkAdd>
            // }
          >
            <Notes />
          </CollapseGroup>
        </CardContent>
      </Card>

      <Grid container spacing={2}>
        {hasBankingProduct && (
          <Grid item md={hasFundingProduct ? 6 : 12} xs={12}>
            <BankingQuickLinks />
          </Grid>
        )}
        {hasFundingProduct && (
          <Grid item md={hasBankingProduct ? 6 : 12} xs={12}>
            <CreditQuickLinks />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default CustomerProfileView;
